import * as logger from 'loglevel';
import axiosWrapper from '../../helpers/axiosWrapper';
import { NO_DURATION_DEFINED } from '../../helpers/axiosWrapper/cache';

// const getSortingComparator = (sorting) => {
//   if (sorting) {
//     if (sorting.name) {
//       if (sorting.name.toLowerCase() === 'asc') return (a, b) => (a.label < b.label ? -1 : 1);
//       if (sorting.name.toLowerCase() === 'desc') return (a, b) => (a.label > b.label ? -1 : 1);
//     } else {
//       if (sorting.weight) {
//         if (sorting.weight.toLowerCase() === 'asc') return (a, b) => (a.weight < b.weight ? -1 : 1);
//         if (sorting.weight.toLowerCase() === 'desc')
//           return (a, b) => (a.weight > b.weight ? -1 : 1);
//       }
//     }
//   }
//   return undefined;
// };

/**
 * Transforming tags from location services api
 * @param {*} tagsRawData
 */
const transformData = (tagsRaw) => {
  return tagsRaw.map(({ dictionaryId, name, weight }) => ({
    value: dictionaryId,
    label: name,
    weight
  }));
};

/**
 * Makes sure the location service response is complain with a basic schema
 * @param {*} traveler
 */
const validateTravelerResponse = (traveler) => {
  const validation = { isValid: true, message: '' };
  if (!traveler || typeof traveler !== 'object') {
    validation.isValid = false;
    return {
      isValid: false,
      data: traveler,
      message: 'INTEGRATION__LOCATION_SERVICE: airports must be an object'
    };
  }
  if (traveler.tags.length > 0) {
    const tag = traveler.tags[0];
    if (!tag.name || !tag.dictionaryId) {
      return {
        isValid: false,
        data: tag,
        message:
          'INTEGRATION__LOCATION_SERVICE: Category SCHEMA is invalid, please check API documentation.'
      };
    }
  }
  return validation;
};

/**
 * Retrieve traveler interest from the location service Endpoint
 * @param {*} filter
 * @param {*} integrationSettings
 */
const getTravelerInterest = (filter, integrationSettings, meta, pageContext) => {
  if (filter['travelerInterest'] !== undefined) {
    return new Promise((resolve, reject) => {
      if (!integrationSettings) {
        const MESSAGE = `INTEGRATION__LOCATION_SERVICE: **integrationSettings** not specified.`;
        logger.error(MESSAGE);
        reject(MESSAGE);
      }

      const v3LocationService = integrationSettings.v3LocationService || {};
      const { cache = false, cacheDuration = NO_DURATION_DEFINED } = v3LocationService;
      const filterCopy = { ...filter };
      if (
        !v3LocationService ||
        !v3LocationService.method ||
        !v3LocationService.endPoint ||
        !v3LocationService.headers
      ) {
        const MESSAGE = `INTEGRATION__LOCATION_SERVICE: **integrationSettings.v3LocationService** configuration issues.`;
        logger.error(MESSAGE);
        reject(MESSAGE);
      }

      const { travelerInterest: { categories = [] } = {} } = filterCopy;
      const promises = [];
      categories.forEach(({ id, sort = [] }) => {
        let params = '';
        sort.forEach((item) => {
          params =
            (!params ? params : params + '&') +
            `sortBy[${Object.keys(item)}]=${item[Object.keys(item)]}`;
        });
        promises.push(
          axiosWrapper(
            {
              // PENDING: Add sorting params
              // https://openair-dev.airtrfx.com/location-service/v3/ab/categories/60a3c2b455f8067a5e96ddbe/language/en?sortBy[TAG_LOCATION_COUNT]=DESC
              url: `${v3LocationService.endPoint.replace(
                new RegExp(`(@@|%%)categoryId(@@|%%)`, 'g'),
                id
              )}?${params}`,
              method: v3LocationService.method,
              headers: { ...v3LocationService.headers }
            },
            {
              resource: 'INTEGRATION__LOCATION_SERVICE',
              meta,
              pageContext,
              integrationSettings,
              cache,
              cacheDuration
            }
          )
        );
      });

      Promise.all(promises).then((response) => {
        const resp = {};
        response.forEach(({ data }) => {
          const validation = validateTravelerResponse(data);
          if (validation.isValid) {
            const { dictionaryId, name, tags } = data;
            resp[dictionaryId] = {
              id: dictionaryId,
              name,
              options: transformData(tags)
            };
          } else {
            logger.error(validation.message, validation.data);
            reject(response.data);
          }
        });
        resolve(resp);
      });
    });
  } else {
    return new Promise(
      () => {},
      () => {}
    );
  }
};

export { getTravelerInterest, transformData };
